<template>
<div class="component">
    <div class="consumptionCarousel" v-if="consumptionData.length=3">
        <consumptionCarouselItem class="leftCircle" @moredetailsClicked="rotateLeft()" @click="activeCircle=2" :class="{'activeCircle': activeCircle==0,'inactiveCircle': activeCircle!=0}" :consumptionData="this.consumptionData[circleData[0]]" :isActive="activeCircle==0" />
        <consumptionCarouselItem class="middleCircle" :class="{'activeCircle': activeCircle==1,'inactiveCircle': activeCircle!=1}" :consumptionData="this.consumptionData[circleData[1]]" :isActive="activeCircle==1" />
        <consumptionCarouselItem class="rightCircle" @moredetailsClicked="rotateRight()" :class="{'activeCircle': activeCircle==2,'inactiveCircle': activeCircle!=2}" :consumptionData="this.consumptionData[circleData[2]]" :isActive="activeCircle==2" />
    </div>
</div>
</template>

<script>
import consumptionCarouselItem from '@/components/Devices/DeviceCarousel/consumptionCarouselItem.vue'

export default {
    name: 'component',
    props: [],
    components: {
        consumptionCarouselItem
    },
    mounted: function () {
        this.getDeviceConsumptionData();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            consumptionData: [],
            activeCircle: 1,
            circleData: {
                0: 2,
                1: 0,
                2: 1
            }
        }
    },
    methods: {
        rotateLeft() {
            let circleLeft = this.circleData[1];
            let circleMiddle = this.circleData[0];
            let circleRight = this.circleData[2];
            this.circleData[0] = circleLeft;
            this.circleData[1] = circleMiddle;
            this.circleData[2] = circleRight;

        },
        rotateRight() {
            let circleLeft = this.circleData[0];
            let circleMiddle = this.circleData[2];
            let circleRight = this.circleData[1];
            this.circleData[0] = circleLeft;
            this.circleData[1] = circleMiddle;
            this.circleData[2] = circleRight;
        },

        getDeviceConsumptionData() {
            this.consumptionData = [];
            this.consumptionData.push({
                Title: this.$t('enaq_translation_devices_own'),
                Consumption: Math.floor(Math.random() * 100)+100,
                Costs: Math.floor(Math.random() * 20)+20,
                CostAverage: Math.floor(Math.random() * 10)+10,
                CostSaving: Math.floor(Math.random() * 7)+7,
                ConsumptionAverage: Math.floor(Math.random() * 100)+90,
                CO2: Math.floor(Math.random() * 300)+200,
                Icon: "icons/Profile_Icon.png",
                Rating: 0,
                CircleColorStart: "#504596",
                CircleColorEnd: "#009FBB",
                HeaderColor: "#003E68",
                RatingPercentage: Math.floor(Math.random() * 98)+1,

            });

            this.consumptionData.push({
                Title: this.$t('enaq_translation_devices_quarter'),
                Consumption: Math.floor(Math.random() * 1000)+1000,
                Costs: Math.floor(Math.random() * 150)+800,
                CostAverage: Math.floor(Math.random() * 80)+50,
                CostSaving: Math.floor(Math.random() * 40)+130,
                ConsumptionAverage: Math.floor(Math.random() * 300)+500,
                CO2: Math.floor(Math.random() * 1000)+2000,
                Icon: "icons/Quarter_Icon.png",
                Rating: 1,
                CircleColorStart: "#F60363",
                CircleColorEnd: "#FF745C",
                HeaderColor: "#89003E",
                RatingPercentage: Math.floor(Math.random() * 98)+1,

            })

            this.consumptionData.push({
                Title: this.$t('enaq_translation_devices_house'),
                Consumption: Math.floor(Math.random() * 200)+500,
                Costs: Math.floor(Math.random() * 50)+200,
                CostAverage: Math.floor(Math.random() * 30)+80,
                CostSaving: Math.floor(Math.random() * 20)+25,
                ConsumptionAverage: Math.floor(Math.random() * 100)+250,
                CO2: Math.floor(Math.random() * 400)+500,
                Icon: "icons/Home_Icon.png",
                Rating: 2,
                CircleColorStart: "#FF8A00",
                CircleColorEnd: "#DCB900",
                HeaderColor: "#CC5C00",
                RatingPercentage: Math.floor(Math.random() * 98)+1,

            })

        },
    },
    computed: {},
}
</script>

<style scoped>
.inactiveCircle {
    width: 30%;
    display: inline-block;
}

.activeCircle {
    width: 40%;
    display: inline-block;
}

.leftCircle{
    padding-left:10%
}

.rightCircle{
    padding-right:30%;
}
</style>
